import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#E8D5C4', // Beige/Rosado claro
      light: '#F5EDE4',
      dark: '#D4C0A8',
      contrastText: '#722F37',
    },
    secondary: {
      main: '#722F37', // Borgoña/Vino tinto
      light: '#9A4A4F',
      dark: '#4A1E24',
      contrastText: '#FFFFFF',
    },
    accent: {
      main: '#DAA520', // Dorado
      light: '#E8C547',
      dark: '#B8941A',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2C1810',
      secondary: '#722F37',
    },
    error: {
      main: '#D32F2F',
    },
    warning: {
      main: '#DAA520',
    },
    info: {
      main: '#1976D2',
    },
    success: {
      main: '#2E7D32',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h1: {
      color: '#722F37',
      fontWeight: 600,
    },
    h2: {
      color: '#722F37',
      fontWeight: 600,
    },
    h3: {
      color: '#722F37',
      fontWeight: 600,
    },
    h4: {
      color: '#722F37',
      fontWeight: 600,
    },
    h5: {
      color: '#722F37',
      fontWeight: 500,
    },
    h6: {
      color: '#722F37',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: '#722F37',
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#4A1E24',
          },
          '&.MuiButton-containedPrimary': {
            backgroundColor: '#E8D5C4',
            color: '#722F37',
            '&:hover': {
              backgroundColor: '#D4C0A8',
            },
          },
          '&.MuiButton-containedSecondary': {
            backgroundColor: '#722F37',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#4A1E24',
            },
          },
        },
        outlined: {
          borderColor: '#722F37',
          color: '#722F37',
          '&:hover': {
            borderColor: '#4A1E24',
            backgroundColor: 'rgba(114, 47, 55, 0.04)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          // backgroundColor: '#722F37',
          // color: '#FFFFFF',
          '& .MuiTypography-root': {
            color: '#111', // Letras negras solo en el header
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&.MuiChip-colorPrimary': {
            backgroundColor: '#E8D5C4',
            color: '#722F37',
          },
          '&.MuiChip-colorSecondary': {
            backgroundColor: '#722F37',
            color: '#FFFFFF',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(114, 47, 55, 0.1)',
          '&:hover': {
            boxShadow: '0 4px 16px rgba(114, 47, 55, 0.15)',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#F5EDE4',
            color: '#722F37',
            fontWeight: 600,
          },
        },
      },
    },
  },
});

export default theme; 